<script>
  import { tick } from "svelte";
  import { useNavigate } from "svelte-navigator";
  import { filtersConfigStore } from "@stores/filtersConfigStores.js";
  import { getApplicableFilters } from "../../../../lib/util/getApplicableFilters";
  import { ROUTES } from "../../../../lib/util/routes.js";
  // ui-elements
  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";
  import ZoomableTreemap from "lib/components/zoomableTreemap/ZoomableTreemap.svelte";
  import Filter from "./components/filter/Filter.svelte";

  // sidenav

  import { Accordion, SectionWrapper, Button } from "paxray-components-svelte";
  import AppSelection from "./components/appSelection.svelte";
  import AppInformation from "./components/appInformation.svelte";
  import Header from "lib/components/Header.svelte";
  import { formatTimeDelta } from "lib/util/formatfunctions.js";
  import * as yootils from "yootils";
  import { pmfilters } from "lib/stores.js";
  import { fetchWithSession } from "lib/util/fetchWithSession.js";
  import FilterToast from "./components/FilterToast.svelte";
  import ButtonNumberInput from "../../../../lib/components/ButtonNumberInput.svelte";
  import {
    ARROW_LEFT_ICON,
    FULLSCREEN_ICON,
    FULLSCREEN_OFF_ICON,
    SQUARE_LANDSCAPE_ICON,
  } from "@utils/icons.js";

  export let analysisid;

  const navigate = useNavigate();
  const { setCurrentView } = filtersConfigStore;

  let currentApp = [""];
  let selectedApp = "";
  let windowPartitionsLoading = false;
  let loading = true;
  let optionTabs = ["Time", "Interactions"];

  let applicationlist = [];
  let windowlist = [];
  let currentWindowList = [];

  let fullscreen = false;
  let disabledlevels = [1, 2];
  let selectedLevel = 0;
  let partitionlabel = 0;

  let percentage = 1;

  let selectedKPIindex = 0;
  let treeData = {};
  let selectedLevelOptions = ["Applications", "Windows"];

  let showToast = false;

  let zoomableTreemap;

  $: if (
    $pmfilters &&
    $filtersConfigStore.storeLoaded &&
    selectedKPIindex !== null &&
    selectedKPIindex !== undefined
  ) {
    selectedLevelOptions =
      selectedKPIindex === 0
        ? ["Applications", "Windows"]
        : ["Applications", "Windows", "Buttons"];

    loadTree();
    getWindowPartitions();
  }

  // $: getWindowPartitions();

  $: {
    if (selectedKPIindex !== null) {
      currentApp = ["Applications"];
      selectedLevel = 0;
      setDisabledLevels();
      getCurrentAplicationlist();
    }
  }

  $: {
    if (selectedLevel >= 0) setDisabledLevels();
  }

  $: {
    if (!selectedApp) {
      downLevel();
    }
  }

  $: if (currentApp[0]) {
    updateAppSelection();
  }

  $: {
    if (!isNaN(selectedApp)) {
      getCurrentWindow();
    } else {
      currentApp[0] = selectedApp;
    }
  }

  $: {
    treeData;
    getCurrentAplicationlist();
  }

  $: {
    if (currentApp[0]) getCurrentWindowsList();
  }

  $: currentAppData =
    selectedLevel === 0 || selectedLevel === 1
      ? applicationlist
      : currentWindowList;

  function setDisabledLevels() {
    if (selectedLevel === 0) {
      disabledlevels = [1, 2];
    } else if (selectedLevel === 1) {
      disabledlevels = [2];
    } else {
      disabledlevels = [];
    }
  }

  async function loadTree() {
    setCurrentView("App Drilldown", optionTabs[selectedKPIindex]);
    await tick();
    getTree();
  }

  function getTree() {
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);

    if (selectedKPIindex === 0) {
      getTreeTime(applicableFilters);
    } else {
      getTreeInteractions(applicableFilters);
    }
  }

  function downLevel() {
    if (selectedLevel > 0) {
      selectedLevel = selectedLevel - 1;
    }
    setDisabledLevels();
  }

  function updateAppSelection() {
    if (currentApp[0] !== selectedApp) {
      if (selectedLevel === 2) {
        if (windowlist.find((app) => app.windowtitle === currentApp[0])) {
          selectedApp = windowlist.find(
            (app) => app.windowtitle === currentApp[0],
          ).id;
        }
      } else {
        selectedApp = currentApp[0];
      }
    }
  }

  function getCurrentWindow() {
    if (selectedApp) {
      currentApp[0] = windowlist.find(
        (app) => app.id === selectedApp,
      ).windowtitle;
      levelUp();
    }
  }

  function levelUp() {
    if (selectedLevel < 2) {
      selectedLevel = selectedLevel + 1;
    }
    setDisabledLevels();
  }

  function getCurrentWindowsList() {
    if (selectedLevel < 1) {
      currentWindowList = [];
    }
    if (
      windowlist.filter((app) => app.clearname === currentApp[0]).length > 0
    ) {
      currentWindowList = windowlist.filter(
        (app) => app.clearname === currentApp[0],
      );
      if (
        currentApp[0] !== "Aplications" &&
        treeData.children.find((data) => data.name === currentApp[0])
      ) {
        currentWindowList.forEach((app) => {
          app.disable = !treeData.children
            .filter((data) => data.name === currentApp[0])[0]
            .children.find((data) => data.name === app.windowtitle);
        });
      }
    }
  }

  function getCurrentAplicationlist() {
    applicationlist.forEach((app) => {
      app.disable = !treeData.children.find((data) => data.name === app.id);
    });
  }

  function getWindowPartitions() {
    windowPartitionsLoading = true;
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/getWindowPartitions?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        windowlist = data;
        windowPartitionsLoading = false;
      });

    fetchWithSession(
      `/api/analysis/AppOverviewKPIs?analysisid=${analysisid}&filter=${filterString}`,
    )
      .then((res) => res.json())
      .then((data) => {
        applicationlist = data;
        windowPartitionsLoading = false;
      });
  }

  // AppScoresTreeTime will be use for time tab

  function getTreeInteractions(applicableFilters) {
    loading = true;
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/AppScoresTreeInteractions?analysisid=${analysisid}&filter=${filterString}&cutoffpercentage=${percentage / 100}`,
    )
      .then((res) => res.json())
      .then((data) => {
        treeData = data;
        if (treeData.children.length === 0 && applicableFilters.length > 0) {
          showToast = true;
        }
        loading = false;
      });
  }

  function getTreeTime(applicableFilters) {
    loading = true;
    const filterString = JSON.stringify(applicableFilters);
    fetchWithSession(
      `/api/analysis/AppScoresTreeTime?analysisid=${analysisid}&filter=${filterString}&cutoffpercentage=${percentage / 100}`,
    )
      .then((res) => res.json())
      .then((data) => {
        treeData = data;
        if (treeData.children.length === 0) {
          showToast = true;
        }
        loading = false;
      });
  }

  function exportApplicationLists() {
    const applicableFilters = getApplicableFilters($pmfilters[analysisid]);
    const filterString = JSON.stringify(applicableFilters);
    let fetchurl;
    if (selectedLevel) {
      fetchurl = `/api/analysis/getWindowPartitions?analysisid=${analysisid}&filter=${filterString}&export=true&windowid=${currentApp[0]}`;
    } else {
      fetchurl = `/api/analysis/AppOverviewKPIs?analysisid=${analysisid}&filter=${filterString}&export=true&applicationid=${currentApp[0]}`;
    }
    fetchWithSession(fetchurl)
      .then((res) => res.blob())
      .then((data) => {
        const element = document.createElement("a");
        const file = new Blob([data], { type: "application/vnd.ms-excel" });
        element.href = URL.createObjectURL(file);
        element.download = "exportapplications.xlsx";
        document.body.appendChild(element);
        element.click();
      });
  }

  function handleDownload() {
    if (zoomableTreemap) zoomableTreemap.downloadSVG();
  }
</script>

<FilterToast bind:showToast></FilterToast>

<Header section="Usage Analysis" breadcrumb="App Drilldown">
  <Button
    text="To Dashboard"
    on:click={() => {
      navigate(`${ROUTES.analysis.dashboard}?analysisid=${analysisid}`);
    }}
    iconLeft={true}
    icon={ARROW_LEFT_ICON}
    kind="secondary"
  />
  <Filter />
</Header>

<SectionWrapper {fullscreen} fitScreen={true}>
  <div slot="main" class="main_wapper">
    <div class="canvas">
      <div class="ui_viewer_wrapper">
        {#key treeData}
          <ZoomableTreemap
            bind:this={zoomableTreemap}
            bind:currentApp
            {loading}
            bind:percentage
            formatfunction={selectedKPIindex ? yootils.commas : formatTimeDelta}
            {treeData}
            bind:level={selectedLevel}
            {partitionlabel}
          />
        {/key}
      </div>
    </div>
    <div class="menu_overlay bottom">
      <div class="buttons_wrapper">
        <ContentSwitcher
          bind:selected={selectedLevel}
          options={selectedLevelOptions}
          fitContent={true}
          disabled={disabledlevels}
        />
      </div>

      <div class="buttons_wrapper">
        <ContentSwitcher
          bind:selected={selectedKPIindex}
          options={optionTabs}
          fitContent={true}
        />
      </div>

      <ButtonNumberInput
        handleMouseDown={() => getTree()}
        placeholder="percentage"
        bind:value={percentage}
        max="100"
        min="0"
        buttonText="Group by more than %"
      />

      <div class="buttons_wrapper">
        <Button
          kind="secondary"
          icon={SQUARE_LANDSCAPE_ICON}
          on:click={handleDownload}
        />
        {#if fullscreen === false}
          <Button
            kind="secondary"
            icon={FULLSCREEN_ICON}
            on:click={() => {
              fullscreen = true;
            }}
          />
        {:else}
          <Button
            kind="secondary"
            icon={FULLSCREEN_OFF_ICON}
            on:click={() => {
              fullscreen = false;
            }}
          />
        {/if}
      </div>
    </div>
  </div>

  <div class="menu" slot="menu">
    <Accordion heading="App Selection" open={true}>
      {#key selectedLevel}
        <AppSelection
          appData={selectedLevel &&
          selectedKPIindex &&
          currentWindowList.length > 0
            ? currentWindowList
            : applicationlist}
          bind:currentApp={selectedApp}
          bind:selectedLevel
          windowSelectionEnabled={false}
          {loading}
          exportfunction={exportApplicationLists}
        />
      {/key}
    </Accordion>
    <Accordion heading="App Information" open={true}>
      <AppInformation
        summary={true}
        appData={currentAppData}
        currentApp={currentApp[0] === "Applications" ? "" : currentApp[0]}
        {loading}
      />
    </Accordion>

    <!-- <Accordion heading="Settings" open={false}>
      <div class="toggle_wrapper">
        <Toggle text="UI-Elements" bind:active={drawUIElements} />
        <Toggle text="Clusters" bind:active={drawClicks} />
        <Toggle text="Screenshot" bind:active={drawScreenshot} />
        <div class="upload_wrapper">
          <Button
            kind="secondary"
            iconLeft={true}
            enlarge={true}
            icon={UPLOAD_ICON}
            text="Upload Screenshot"
            disable={true}
          />
        </div>
      </div>
    </Accordion> -->
  </div>
</SectionWrapper>

<style>
  /* .upload_wrapper {
    padding-top: 1rem;
    margin-top: 1rem;
    border-top: 1px solid #d9d9d9;
  }

  .toggle_wrapper {
    display: flex;
    flex-direction: column;
  } */

  .main_wapper {
    position: relative;
    height: 100%;
    width: 100%;
    min-width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .menu_overlay {
    position: absolute;
    width: 100%;
    z-index: 1; /* Stellt sicher, dass das Overlay über dem Canvas liegt */
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bottom {
    bottom: 0;
  }

  .canvas {
    height: calc(100% - 110px);
    width: 100%;
    z-index: 0; /* Platziert das Canvas hinter den Overlays */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .buttons_wrapper {
    display: flex;
    gap: 0.5rem;
    user-select: none;
  }

  .menu {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .ui_viewer_wrapper {
    height: 100%;
    width: 100%;
  }
</style>
